<template>
	<div class="e-icons accordion">
		<div
			class="toggleClick"
			:class="[{ 'activeToggle': expanded }, { 'mobile': isMobile }]"
			@click="toggle"
		>
			{{ header }}
			<span v-if="!isMobile" class="arrow" />
		</div>
		<transition name="expand">
			<slot v-if="!expanded" name="collapsed" />
		</transition>
		<transition name="slide">
			<div v-show="expanded" class="toggleContainer">
				<slot />
			</div>
		</transition>
	</div>
</template>

<script>
export default {
	props: {
		header: { type: String, required: true },
		isMobile: { type: Boolean, default: false },
		startExpanded: { type: Boolean, default: true },
	},
	data: function () {
		return {
			expanded: true
		};
	},
	beforeMount() {
		this.expanded = this.startExpanded;
	},
	methods: {
		toggle() {
			if (!this.isMobile)
				this.expanded = !this.expanded;
		}
	}
};
</script>